"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cellar = void 0;
/**
 * oneAudi OS Shared Memory Store
 * @copyright (c) Audi Business Innovation GmbH
 * @license Private
 * @private
 */
/**.
 * This module is meant to be loaded just once as a singleton to ensure that
 * module scope is not duplicated by loading multiple versions.
 * All storage keys are unique references. It is not possible to overwrite.
 * References are pointers in memory. Pointers are immutable, but objects you point to is still mutable.
 *
 * Usage:
 *    import store from '@oneaudi/oneaudi-os-store';
 *
 *    const success = store.add('registry', registry);
 *    console.log(success); // true if successful, false when 'registry' already existed
 *    const registryFromStore = store.get('registry');
 *
 * @private
 */
var cellar = new Map();
exports.cellar = cellar;
/**
 * This object provides with methods for adding and retrieving memory from the cellar.
 * Most importantly, we get to use Type Safety for retrieved memory objects.
 * Additionally, we ensure that keys are never overwritten.
 */
var store = {
    /**
     * Get an item from memory with type safety
     * @param key
     */
    get: function (key) {
        return cellar.get(key);
    },
    /**
     * Register a new memory key
     * @param key
     * @param value
     * @returns false if key already exists and registration failed. True when successful.
     */
    add: function (key, value) {
        if (cellar.has(key)) {
            return false;
        }
        cellar.set(key, value);
        return true;
    },
    has: function (key) {
        return cellar.has(key);
    },
    delete: function (key) {
        return cellar.delete(key);
    },
    cellar: cellar,
};
// Expose cellar in read-only format. This can help with debugging
Object.defineProperty(store, 'cellar', {
    enumerable: true,
    configurable: false,
    writable: false,
    value: cellar,
});
exports.default = store;
